import Link from "next/link";
import FAIcon from "@/components/icons/faIcon";

export default function MenuFeatureBarLink({
  href,
  onNavigate,
  description,
  cta,
  className = "",
  descriptionClassName = "",
  ctaTextClassName = "",
  buttonClassName = "",
}) {
  if (!href || !cta) {
    return null;
  }

  return (
    <Link
      href={href}
      onClick={onNavigate}
      className={`group flex flex-col gap-5 rounded-lg bg-neutral-100 px-6 py-5 mt-4 text-[#06040c] transition-all duration-300 hover:-translate-y-0.5 hover:bg-neutral-200/65 focus-visible:outline-none md:flex-row md:items-end md:justify-between ${className}`}
    >
      <div className="max-w-2xl">
        {description ? (
          <p
            className={`text-sm leading-6 text-[#06040c]/64 ${descriptionClassName}`}
          >
            {description}
          </p>
        ) : null}
      </div>

      <div className="flex items-center gap-3 md:shrink-0">
        <span
          className={`max-w-40 font-raleway text-[1.08rem] leading-[1.08] tracking-[-0.045em] text-[#06040c] ${ctaTextClassName}`}
        >
          {cta}
        </span>
        <span
          className={`flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-[#06040c] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${buttonClassName}`}
        >
          <FAIcon icon="arrow-right" size={14} noMargin />
        </span>
      </div>
    </Link>
  );
}
